/* eslint-disable no-useless-escape */
<template>
    <div class="page-editor">
      <CRow>
    <CCol col="10" xl="10">
      <CCard class="pr-0">

        <CCardBody>
          <a-card class="edit-card" style="margin:0;">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted"><span v-if="!isNaN(id) || !isNaN(mid)">Upravuje sa typ konta<span class="text-lowercase"><router-link :to="'/content/' + cttt">{{ct}}</router-link></span> </span><span v-else>Pridávate typ konta</span> </h6>
                            <template v-if="role.title">{{ role.title }}</template><template v-else>Nové konto</template></span>
                          <span slot="extra">


                 </span>
             <div class=" pt-4 pb-4">
                 <div class="pl-4 pr-4">
              <a-tabs  default-active-key="settings" class="w-100" tab-position="left">
<a-tab-pane tab="Nastavenia" key="settings">

                        <template>
                                 <a-form-item label="Názov druhu konta"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                            <a-input class="w-100" v-model="role.title"
                                            />
                                        </a-form-item>
                                         <a-form-item label="Slug druhu konta"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                             <a-input  class="w-100"  v-model="role.slug" />
                                         </a-form-item>
                                        <a-form-item label="Prvá stránka po logine"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                        <a-input  class="w-100"  v-model="role.homepage"
                                        />
                                        </a-form-item>
                        </template>

</a-tab-pane>
<a-tab-pane tab="Právomoci" v-if="id != 'add'" key="permissions">
    <a-form-item><a-checkbox-group :span="12" v-model="role.permissions"  :options="permissions"/></a-form-item>


</a-tab-pane>

<a-tab-pane tab="Dostupné cesty" v-if="id != 'add'" key="routes">
    <a-form-item label="Cesty"><a-checkbox-group :span="12" v-model="role.paths" :options="paths"/></a-form-item>
</a-tab-pane>


<a-tab-pane tab="Typy obsahu" v-if="id != 'add'" key="contenttypes">
    <a-form-item label="Povolené typy obsahu">
      <a-checkbox-group :span="12" v-model="role.ctypes" :options="contenttypes"/>
    </a-form-item>
</a-tab-pane>
              </a-tabs>
 </div></div>
        </a-card>
        </CCardBody>
        </CCard>
        </CCol>
        <CCol col="2" xl="2" class=" option-card">
<CCard class="pl-0">
  <CCardBody>
    <a-card class="edit-card" style="margin:0; padding:15px;">

                                <div class="option-buttons">
                                  <router-link to="/roles"><a-button>Späť na všetky kontá</a-button></router-link>

                                    <a-button type="primary"  class="fs-12"  @click="handleSubmit">Uložiť</a-button>
                            </div>

      </a-card>

  </CCardBody>
</CCard>
  </CCol>
        </CRow>
        </div>
</template>
<script>
    import {API_URL} from "../api";
    import {authHeader} from "../_helpers";
    import {dataService} from "../_services";
    import Vue from "vue"
    import FormItem from 'ant-design-vue'

    Vue.use(FormItem);


    export default {
        name: 'role',
        props: ['id'],

        data() {
            return {
                head: authHeader(),
                send: API_URL,
                permissions: [],
                colorsto: JSON.parse(localStorage.colors),
                paths: [],
                perm:[],
                contenttypes:[],
                 labelCol: { span: 4 },
                defaultLanguage:'sk',
                wrapperCol: { span: 20 },
                reloadimages:{},
                formItemLayout: {
                    labelCol: {span: 6},
                    wrapperCol: {span: 14},
                },
                roleId: {
                    uid: this.id
                },
                role: {
                    title: '',
                    slug: '',
                },
            }
        },
        methods: {
            handleSubmit() {
                let $role_data = this.role;
                dataService.axiosPost(this.$options.name, $role_data).then(results => {

                    if (results.data.message) {
                        this.$router.push("/" + this.$options.name + "/" + results.data.message);
                    }

   dataService.axiosPost("updateinfo", {"rid":this.id,"pages":this.role.paths,"ctypes":this.role.ctypes})
                });
            },
        },
        mounted() {
            if (!isNaN(this.id)) {
                dataService.axiosFetch(this.$options.name, this.id).then(results => {
                    this.role = results;
                });
                dataService.axiosFetch("allcontenttypes").then(results => {
                    this.contenttypes = dataService.getCheckboxOptions(results);

                });
                dataService.axiosFetch("paths").then(results => {
                    this.paths = results;
                });
                dataService.axiosFetch("permissions").then(results => {
                    this.permissions = dataService.getCheckboxSlugOptions(results);
                });
            }
        }
    };
</script>
<style>

    .input-group .input-group-prepend .input-group-text {
        border: 0;
    }

    .ant-checkbox-group-item
    {display:inline-block;width:100%; margin-bottom:10px;}
</style>
